"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Input = _interopRequireDefault(require("../Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AutoformatInput = ({
  decimalCount,
  decimalSeparator,
  error,
  initialValue,
  invalidFormatValidationMessage,
  onBlur,
  onChange,
  prefix,
  suffix,
  validationMessage,
  ...props
}) => {
  const thousandSeparator = decimalSeparator === ',' ? '.' : ',';
  const [currentValue, setCurrentValue] = (0, _react.useState)(initialValue);
  const [invalidFormatError, setInvalidFormatError] = (0, _react.useState)(false);

  const handleIsAllowed = incomingValue => {
    setInvalidFormatError(false); // leading zero should be valid only if it's immediately followed by a separator

    const hasValidLeadingZero = !incomingValue.formattedValue.match(/^0[0-9]/);
    const isValidIncomingValue = incomingValue.formattedValue !== currentValue;
    const isAllowedValue = isValidIncomingValue && hasValidLeadingZero;

    if (!isAllowedValue) {
      setInvalidFormatError(true);
    }

    return isAllowedValue;
  };

  const handleValueChange = incomingValue => {
    setCurrentValue(incomingValue.formattedValue);
  };

  const handleBlur = event => {
    setInvalidFormatError(false);
    const hasTrailingDecimalSeparator = currentValue.slice(-1) === decimalSeparator;

    if (hasTrailingDecimalSeparator) {
      const trimmedValue = currentValue.slice(0, -1);
      setCurrentValue(trimmedValue);

      if (onChange) {
        onChange({
          target: {
            value: trimmedValue
          }
        });
      }
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, _extends({}, props, {
    allowLeadingZeros: true,
    allowNegative: false,
    customInput: _Input.default,
    decimalScale: decimalCount,
    decimalSeparator: decimalSeparator,
    error: error || invalidFormatError,
    isAllowed: handleIsAllowed,
    onBlur: handleBlur,
    onValueChange: handleValueChange,
    prefix: prefix,
    thousandSeparator: thousandSeparator,
    validationMessage: invalidFormatError ? invalidFormatValidationMessage : error && validationMessage,
    value: currentValue,
    suffix: suffix,
    onChange: onChange
  }));
};

AutoformatInput.propTypes = { ..._Input.default.propTypes,
  decimalCount: _propTypes.default.number,
  decimalSeparator: _propTypes.default.oneOf([',', '.']),
  initialValue: _propTypes.default.string,
  invalidFormatValidationMessage: _propTypes.default.string,
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string
};
AutoformatInput.defaultProps = { ..._Input.default.defaultProps,
  decimalCount: 5,
  decimalSeparator: '.',
  initialValue: '',
  invalidFormatValidationMessage: "You're trying to insert invalid values.",
  prefix: '',
  suffix: ''
};
var _default = AutoformatInput;
exports.default = _default;